"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function FormChannelsAdmin(_a) {
    var _b;
    var user = _a.user, setUser = _a.setUser, channel = _a.channel;
    var _c = ra_fetch_1.useApi('backend').index('users.channels', {
        id: user.id,
        channel_id: channel.id,
    }), channels = _c[0], setChannels = _c[1];
    var _d = ra_fetch_1.useApi('auth').delete('users.channels', {
        id: user.id,
        channel_id: channel.id,
    }), deleteChannel = _d[0], submitDelete = _d[1];
    var current = channels.data.findBy('id', channel.id);
    if (channels.loading) {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    var roleValue = user.role_id || ((_b = current.role) === null || _b === void 0 ? void 0 : _b.id);
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Title, null, "Kanaal rol"),
        react_1.default.createElement(storybook_1.Forms.Field, { className: 'flex gap-4' },
            react_1.default.createElement(storybook_1.Users.FormRole, { value: roleValue, setUser: setUser }),
            react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return submitDelete({ role_id: current.role.id }).then(function (response) {
                    if (!response.errors.length) {
                        window.location.href = process.env.NEXT_PUBLIC_STORYBOOK_DASHBOARD_V2_URL + "/users";
                    }
                }); }, type: 'light', icon: 'trash', disabled: !roleValue, outline: true })));
}
exports.default = FormChannelsAdmin;
